import React from "react";
//#region types
import { FieldHandles, FormFieldWrapperProps } from "models/propTypes/genericFormProps";
import { StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import FormFieldWrapper from "./formFieldWrapper";
import RoundButton from "../buttons/roundButton";
import Icon from "../icon";
import { useFormikContext } from "formik";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

function RemovableFormFieldWrapper<T extends Record<string, any>>(props: FormFieldWrapperProps<T>) {
  const { setFieldValue } = useFormikContext<T>();
  const { field, name } = props;

  const fieldRef = React.useRef<FieldHandles>(null);

  const onRemoveValueClick = () => {
    (fieldRef.current && fieldRef.current.change(undefined)) || setFieldValue(name, undefined);
  };

  return (
    <Grid container direction="row" spacing={1} className={cssExports.removableFormField}>
      <Grid item className={cssExports.label}>{`${LocalizationHelperInstance.getFormattedMessage(
        field.label,
        field.label
      )}:`}</Grid>
      <Grid item>
        {
          <FormFieldWrapper<T>
            fieldRef={fieldRef}
            {...props}
            field={{
              ...field,
              label: "",
              descriptionText: undefined,
              readonly: true,
              widthColumnCount: false,
            }}
          />
        }
      </Grid>
      <Grid item>
        <RoundButton
          size="xs"
          displayType={StyleEnums.DisplayType.None}
          className={cssExports.close}
          onClick={onRemoveValueClick}
        >
          <Icon icon={IconDefinitionConstants.WTimes} />
        </RoundButton>
      </Grid>
    </Grid>
  );
}

export default RemovableFormFieldWrapper;
